import axios from 'axios';

const API = axios.create({
  baseURL: 'https://job-portal-back123.herokuapp.com/', 
  credentials: "include",
  withCredentials: true,
  headers: {
    Authorization: localStorage.getItem("token")
  }
});

API.defaults.headers.common['Authorization'] = localStorage.getItem("token")
// export const uploadFile = (data) => API.post('/upload', data);

////////////////////faq apis

// export const addFaq = async (faq) => {
//   const res = await fetch('https://job-portal-back123.herokuapp.com/admin/faq',{
//     method: "POST",
//     headers: {
//       "content-type": "application/json",
//       accept : "application/json",
//       Authorization: localStorage.getItem("token")
//     },
//     mode: "cors",
//     credentials: "include",
//     withCredentials: true,
//     body: JSON.stringify({
//       ...faq
//     })
//   })


//   return res;
// }
// API.post(`/admin/faq`, faq);

// done
export const addFaq = (faqData) => API.post(`/admin/faq`, faqData);
export const getAllFaqs = () => API.get(`/faqs`);
export const editFaq = (faqId, faqData) => API.put(`/admin/faq/${faqId}`, faqData);
export const deleteFAQWithId = (faqId) => API.delete(`/admin/faq/${faqId}`);

/////////////////// testimonial apis

export const addTestimonial = (testimonal) => API.post(`/admin/testimonial`, testimonal);

export const getAllTestimonials = () => API.get(`/testimonials`);

export const deleteTestimonialId = (testimonalID) => API.delete(`/admin/testimonial/${testimonalID}`);

export const editTestimonial = (testimonialId, testimonial) => API.put(`/admin/testimonial/${testimonialId}`, testimonial);
////////////////// job apis

export const postJob = (job) => API.post(`/admin/job`,  job);


export const editJob = (jobId, jobData) => API.put(`/admin/job/${jobId}`, jobData);

export const getAllJobs = (pageno, pagelimit) => API.get(`/allJobs`);

export const getJobWithId = (jobId) => API.get(`/job/${jobId}`);

export const deleteJobWithId = (jobId) => API.delete(`/admin/job/${jobId}`);

////////////////// contact apis

// done
export const addContact = (contact) => API.post(`/contact`, contact);

export const getAllContacts = () => API.get(`/admin/contact/all`);

export const deleteContactWithId = (contactId) => API.delete(`/admin/contact/${contactId}`);
///////////////// application apis

// done - upload baki hai
export const sendApplication = (application) => API.post(`/application`, application);

export const getAllApplications = () => API.get(`/admin/application/`);

export const getAppForJobid = (jobId) => API.get(`/admin/application/job/${jobId}`);

export const deleteApplicationWithId = (appId) => API.delete(`/admin/application/${appId}`);


export const sendResume = (application) => API.post(`/resume/send`, application);
export const employerZone = (application) => API.post(`/employerzone`, application);
export const getEmployerzoneData = () => API.get(`/employerzone/all`);

///////////////////////

export const signin = (user) => API.post(`/signin/${user}`)
